import React from 'react';
import { ResponsiveContainer, ComposedChart, Bar, Line, Legend, XAxis, YAxis, Tooltip } from 'recharts';

import Tick from 'components/charts/Tick';
import StatusOverviewTooltip from './statusOverviewTooltip';

import './statusOverviewChart.style.css';

const StatusOverviewChart = ({
    data,
    bars,
    lines,
    xAxisDataKey,
    yAxisTickFormatter,
    syncId = 'stackedBarSync',
    yAxisWidth = 40,
    tooltipFormatter,
    allowDecimalsInYAxis = true,
}) => {
    const renderYTick = (props) => <Tick {...props} formatter={yAxisTickFormatter} />;
    const renderDateTick = (props) => <Tick {...props} />;

    return (
        <ResponsiveContainer minHeight={300}>
            <ComposedChart data={data} stackOffset="sign" barSize={35} syncId={syncId}>
                <Tooltip isAnimationActive={false} content={<StatusOverviewTooltip formatter={tooltipFormatter} />} />
                {bars.map((bar) => (
                    <Bar
                        key={bar.dataKey}
                        dataKey={bar.dataKey}
                        name={bar.dataName}
                        fill={bar.color}
                        stackId="stack"
                        isAnimationActive={false}
                        barSize={40}
                    />
                ))}
                {lines.map((line) => (
                    <Line
                        name={line.dataName}
                        type="monotoneX"
                        key={line.dataKey}
                        dataKey={line.dataKey}
                        fill={line.color}
                        stroke={line.color}
                        strokeWidth={2}
                        strokeDasharray={line.isDotted ? '4 4' : undefined}
                        dot={{ strokeWidth: 0.5 }}
                        activeDot={{ r: 1 }}
                        isAnimationActive={false}
                        legendType="plainline"
                    />
                ))}
                <XAxis
                    dataKey={xAxisDataKey}
                    tick={renderDateTick}
                    height={35}
                    tickMargin={10}
                    interval="preserveStartEnd"
                />
                <YAxis width={yAxisWidth} tickLine={false} allowDecimals={allowDecimalsInYAxis} tick={renderYTick} />
                <Legend />
            </ComposedChart>
        </ResponsiveContainer>
    );
};

export default StatusOverviewChart;
